<template>
  <v-app>
    <component :is="router.currentRoute.value.meta.layout" />
    <app-services />
  </v-app>
</template>

<script setup>
import AppServices from "@/app-services/AppServices.vue";

import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { watch } from "vue";

import { useInstanceStore } from "@/stores/instance";
import { useDialogStore } from "@/stores/dialog";

const router = useRouter();

const instance = useInstanceStore();
const dialog = useDialogStore();
const { fullscreen, breadcrumb } = storeToRefs(instance);

watch(
  [
    () => router.currentRoute.value.params,
    () => router.currentRoute.value.name
  ],
  (newV, oldV) => {
    if (JSON.stringify(newV) === JSON.stringify(oldV)) return;

    fullscreen.value = false;
    breadcrumb.value = "";
    dialog.closeAll();
  }
);
</script>
